<template>
  <div :class="['search-tab', type]">
    <el-tabs type="card" v-model="currentTab" @tab-change="handleTabChange">
      <el-tab-pane name="1">
        <template #label>
          <span class="custom-tabs-label">
            <img :src="icon.hIcon" alt="" srcset="" />
            <span class="fs-xl"
              >{{ label }}五年ASTEM{{
                label === '医院' ? '（综合）' : ''
              }}</span
            >
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane name="2" v-if="type !== 'college'">
        <template #label>
          <span class="custom-tabs-label">
            <img :src="icon.plusIcon" alt="" srcset="" />
            <span class="fs-xl">{{ label }}五年ASTEM（学科）</span>
          </span>
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, reactive, ref } from 'vue'

import hIcon from '@/assets/icons/hospital.png'
import plusIcon from '@/assets/icons/plus.png'

import INFO from '../../constant.js'

const emits = defineEmits(['tab-change'])

const props = defineProps({
  type: {
    type: String
  }
})
const currentTab = ref('1')

const handleTabChange = (value) => {
  // if (currentTab.value === value) return
  emits('tab-change', value)
}

const icon = {
  hIcon,
  plusIcon
}
const label = INFO[props.type].name
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/search-tab.scss';
</style>
